import React from 'react'
import { FieldLabel } from '../form/index'
import AgentSearchSelect from './AgentSearchSelect'

const AgentSearchSelectField = (props) => (
  <FieldLabel {...props} format={null} component={AgentSearchSelect} />
)

export default AgentSearchSelectField
